import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const bottomBar = trigger('bottomBar', [
  state('hidden', style({ height: 0 })),
  state('visible', style({ height: '*' })),
  transition('hidden => visible', [animate('200ms 200ms linear')]),
  transition('visible => hidden', [animate('0ms 200ms linear')]),
]);
